module.exports = __webpack_public_path__ + "img/cartogro-dark.4cd62187.svg";